export const memoraImages = [
  // AI Memory & Legacy Images
  {
    src: "./images/ai_memory_legacy_1.jpeg",
    title: "AI-Powered Memory Preservation",
    description: "Revolutionary technology that preserves and shares important memories across generations through advanced AI systems."
  },
  {
    src: "./images/ai_memory_legacy_2.png",
    title: "Family AI Memory Creation",
    description: "Create lasting digital legacies with AI-powered family memory systems that bridge time and space."
  },
  {
    src: "./images/ai_memory_legacy_3.png",
    title: "Digital Resurrection Technology",
    description: "Advanced AI technology that enables meaningful connections with departed loved ones through preserved memories."
  },
  {
    src: "./images/ai_memory_legacy_4.jpeg",
    title: "Adaptive Memory Preservation",
    description: "AI-powered memory preservation that adapts to modern technology, ensuring memories last forever."
  },
  {
    src: "./images/ai_memory_legacy_5.jpeg",
    title: "Digital Afterlife Innovation",
    description: "Exploring AI's transformative impact on death, memory, and digital immortality for future generations."
  },

  // Family Connections & Generations Images
  {
    src: "./images/family_connections_memories_1.webp",
    title: "Generational Connections",
    description: "Visual representation of family connections and relationships that span across multiple generations."
  },
  {
    src: "./images/family_connections_memories_2.png",
    title: "Building Generational Memories",
    description: "Creating lasting memories and connections that bridge different generations within families."
  },
  {
    src: "./images/family_connections_memories_3.jpeg",
    title: "Family Memory Legacy",
    description: "Preserving precious family moments and stories for future generations to cherish and learn from."
  },

  // Digital Immortality & Beyond Life Images
  {
    src: "./images/digital_immortality_beyond_life_1.jpeg",
    title: "Digital Immortality Through AI",
    description: "How AI, avatars, and advanced technology are reshaping our understanding of life and legacy."
  },
  {
    src: "./images/digital_immortality_beyond_life_2.png",
    title: "AI-Powered Digital Resurrection",
    description: "Revolutionary technology that enables digital resurrection and meaningful connections beyond physical life."
  },
  {
    src: "./images/digital_immortality_beyond_life_3.png",
    title: "Beyond Life and Death",
    description: "Exploring the frontier of digital immortality and how technology transcends traditional boundaries."
  },
  {
    src: "./images/digital_immortality_beyond_life_4.jpeg",
    title: "Quest for Digital Immortality",
    description: "The ongoing quest to achieve digital immortality through advanced AI and memory preservation technology."
  },
  {
    src: "./images/digital_immortality_beyond_life_5.jpeg",
    title: "AI Memory Preservation",
    description: "Innovative AI technology that preserves memories and enables continued connections with loved ones."
  }
];

export default memoraImages;